import { formatNumber } from "accounting"
import { Space, Tag, Typography } from "antd"
import dayjs from "dayjs"

import Private from "../../../../../Components/Private"
import { titleSortFilters } from "../../../../../Components/titleSortFilters"
import Icon from "../../../../../Icon"
import { dateFormat } from "../../../../../Utils/utils"
import { OUTCOME_META } from "../../constants/outcomes"
import { CE_PROGRAM_META } from "../../constants/programs"

const { Text } = Typography

const renderAmount = (value) =>
  value == null ? "—" : <Private>{"$" + formatNumber(value, 2, ",")}</Private>

const renderDate = (value) => {
  if (!value) return "—"
  return (
    <Space direction="vertical" size={0}>
      <Text>{dayjs(value).format(dateFormat)}</Text>
      <Text type="secondary" style={{ fontSize: 12 }}>
        {dayjs(value).format("h:mm A")}
      </Text>
    </Space>
  )
}

export const caseColumnIconMap = {
  date: "calendar_days",
  card: "card",
  program: "processor",
  outcome: "check",
  amount: "money",
  fee_charged: "money"
}

const COLUMN_LABEL = {
  date: "Date",
  card: "Card",
  program: "Program",
  outcome: "Outcome",
  amount: "Amount",
  fee_charged: "Fee charged"
}

const COLUMN_MIN_WIDTH = {
  date: 160,
  card: 140,
  program: 180,
  outcome: 160,
  amount: 140,
  fee_charged: 140
}

const buildTitle = (fieldId, t) => (state) =>
  titleSortFilters({
    title: t(COLUMN_LABEL[fieldId]),
    sorter: true,
    icon: caseColumnIconMap[fieldId],
    stateData: state,
    key: fieldId
  })

const column = (fieldId, t, render) => ({
  key: fieldId,
  dataIndex: fieldId,
  title: buildTitle(fieldId, t),
  sorter: true,
  minWidth: COLUMN_MIN_WIDTH[fieldId],
  render
})

export const getColumns = ({ t }) => ({
  date: { ...column("date", t, renderDate), defaultSortOrder: "descend" },
  card: column("card", t, (last4) => (last4 ? <Private>{last4}</Private> : "—")),
  amount: column("amount", t, renderAmount),
  program: column("program", t, (value) => {
    const meta = CE_PROGRAM_META[value]
    if (!meta) return "—"
    return (
      <Space gap={4}>
        {meta.iconType && <Icon type={meta.iconType} style={{ fontSize: 20, lineHeight: 1 }} />}
        <Text strong>{t(meta.name)}</Text>
      </Space>
    )
  }),
  outcome: column("outcome", t, (value) => {
    const meta = OUTCOME_META[value]
    if (!meta) return "—"
    return (
      <Tag color={meta.color} style={{ margin: 0 }}>
        {t(meta.label)}
      </Tag>
    )
  }),
  fee_charged: column("fee_charged", t, renderAmount)
})
